import React, { useState } from 'react';
import { Button } from 'antd';
import ErrorBoundary from '../../components/Error/ErrorBoundary';

function Bomb() {
  throw new Error('Test error — triggered manually');
}

export function ErrorTest() {
  const [explode, setExplode] = useState(false);

  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>Error Boundary Test Page</h2>
      <p>Click the button below to trigger a React error and test the error boundary + Contact Us link.</p>
      <ErrorBoundary key={explode}>
        {explode ? <Bomb /> : (
          <Button type="danger" onClick={() => setExplode(true)}>
            Trigger Error
          </Button>
        )}
      </ErrorBoundary>
      {explode && (
        <Button style={{ marginTop: 16 }} onClick={() => setExplode(false)}>
          Reset
        </Button>
      )}
    </div>
  );
}

export default ErrorTest;
